module.exports = __webpack_public_path__ + "static/img/6051_phase_function_Paper_Points.f37e633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6051_phase_function_Paper_Points.png
// module id = bhWY
// module chunks = 0